import React from 'react';
import AffilateBlue from '../../assets/img/icons/affilate-blue.svg';

function BankrollList() {
    return ( 
        <div className="bankRollList">
            
            <ul className="affilateList">
                <li>
                    <a href='#' className="affilate_list_name">
                        <p>Username0001</p>
                    </a>
                    <span className='affilate_number'>
                        <img src={AffilateBlue} alt="UserIcon" />
                        1252.23365
                    </span>
                </li>
                <li>
                    <a href='#' className="affilate_list_name">
                        <p>Username0001</p>
                    </a>
                    <span className='affilate_number'>
                        <img src={AffilateBlue} alt="UserIcon" />
                        1252.23365
                    </span>
                </li>
                <li>
                    <a href='#' className="affilate_list_name">
                        <p>Username0001</p>
                    </a>
                    <span className='affilate_number'>
                        <img src={AffilateBlue} alt="UserIcon" />
                        1252.23365
                    </span>
                </li>
                <li>
                    <a href='#' className="affilate_list_name">
                        <p>Username0001</p>
                    </a>
                    <span className='affilate_number'>
                        <img src={AffilateBlue} alt="UserIcon" />
                        1252.23365
                    </span>
                </li>
                <li>
                    <a href='#' className="affilate_list_name">
                        <p>Username0001</p>
                    </a>
                    <span className='affilate_number'>
                        <img src={AffilateBlue} alt="UserIcon" />
                        1252.23365
                    </span>
                </li>
                <li>
                    <a href='#' className="affilate_list_name">
                        <p>Username0001</p>
                    </a>
                    <span className='affilate_number'>
                        <img src={AffilateBlue} alt="UserIcon" />
                        1252.23365
                    </span>
                </li>
                <li>
                    <a href='#' className="affilate_list_name">
                        <p>Username0001</p>
                    </a>
                    <span className='affilate_number'>
                        <img src={AffilateBlue} alt="UserIcon" />
                        1252.23365
                    </span>
                </li>
                <li>
                    <a href='#' className="affilate_list_name">
                        <p>Username0001</p>
                    </a>
                    <span className='affilate_number'>
                        <img src={AffilateBlue} alt="UserIcon" />
                        1252.23365
                    </span>
                </li>
                <li>
                    <a href='#' className="affilate_list_name">
                        <p>Username0001</p>
                    </a>
                    <span className='affilate_number'>
                        <img src={AffilateBlue} alt="UserIcon" />
                        1252.23365
                    </span>
                </li>
                <li>
                    <a href='#' className="affilate_list_name">
                        <p>Username0001</p>
                    </a>
                    <span className='affilate_number'>
                        <img src={AffilateBlue} alt="UserIcon" />
                        1252.23365
                    </span>
                </li>
                <li>
                    <a href='#' className="affilate_list_name">
                        <p>Username0001</p>
                    </a>
                    <span className='affilate_number'>
                        <img src={AffilateBlue} alt="UserIcon" />
                        1252.23365
                    </span>
                </li>
                <li>
                    <a href='#' className="affilate_list_name">
                        <p>Username0001</p>
                    </a>
                    <span className='affilate_number'>
                        <img src={AffilateBlue} alt="UserIcon" />
                        1252.23365
                    </span>
                </li>
                <li>
                    <a href='#' className="affilate_list_name">
                        <p>Username0001</p>
                    </a>
                    <span className='affilate_number'>
                        <img src={AffilateBlue} alt="UserIcon" />
                        1252.23365
                    </span>
                </li>
                <li>
                    <a href='#' className="affilate_list_name">
                        <p>Username0001</p>
                    </a>
                    <span className='affilate_number'>
                        <img src={AffilateBlue} alt="UserIcon" />
                        1252.23365
                    </span>
                </li>
            </ul>
        </div>
     );
}

export default BankrollList;